'use strict';

// Taken from http://there4development.com/blog/2012/05/02/google-chart-color-list/

module.exports = ['#3366CC', '#DC3912', '#FF9900', '#109618', '#990099', '#3B3EAC', '#0099C6', '#DD4477', '#66AA00', '#B82E2E', '#316395', '#994499', '#22AA99', '#AAAA11', '#6633CC', '#E67300', '#8B0707', '#329262', '#5574A6', '#3B3EAC'];


//////////////////
// WEBPACK FOOTER
// ./~/react-google-charts/lib/constants/DEFAULT_CHART_COLORS.js
// module id = 1076
// module chunks = 0